import React from 'react';
import { StructuredData } from './StructuredData';
import { useAnalytics } from '../hooks/useAnalytics';
import { CFA_INFO, SITE_URL, PHONE_DISPLAY } from '../data/constants';

/**
 * Scripts et données transverses au site :
 * - mesure d'audience (inactive tant que l'identifiant n'est pas renseigné)
 * - fiche d'identité de l'organisme pour Google (schema.org)
 */
export function SiteScripts() {
  useAnalytics();
  const organization = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    '@id': `${SITE_URL}/#organization`,
    name: CFA_INFO.name,
    legalName: CFA_INFO.legalName,
    description: "Centre de Formation d'Apprentis certifié Qualiopi à Joigny (Yonne). Formations en alternance dans le commerce, la vente et la relation client : BTS NDRC, TP Conseiller de Vente, TP Négociateur Technico-Commercial.",
    url: SITE_URL,
    telephone: PHONE_DISPLAY,
    email: CFA_INFO.email,
    slogan: CFA_INFO.tagline,
    address: {
      '@type': 'PostalAddress',
      streetAddress: '25 rue Gabriel Cortel',
      postalCode: '89300',
      addressLocality: 'Joigny',
      addressRegion: 'Bourgogne-Franche-Comté',
      addressCountry: 'FR'
    },
    areaServed: [{
      '@type': 'City',
      name: 'Joigny'
    }, {
      '@type': 'City',
      name: 'Auxerre'
    }, {
      '@type': 'City',
      name: 'Sens'
    }, {
      '@type': 'AdministrativeArea',
      name: 'Yonne'
    }],
    identifier: [{
      '@type': 'PropertyValue',
      name: 'SIRET',
      value: CFA_INFO.siret
    }, {
      '@type': 'PropertyValue',
      name: 'UAI',
      value: CFA_INFO.uai
    }, {
      '@type': 'PropertyValue',
      name: "Numéro de déclaration d'activité",
      value: CFA_INFO.nda
    }],
    hasCredential: {
      '@type': 'EducationalOccupationalCredential',
      name: 'Certification Qualiopi',
      description: 'Actions de formation et actions de formation par apprentissage'
    }
  };
  return <StructuredData id="organization" data={organization} data-id="element-648" data-mp="3cn46iy1540mc" />;
}